import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import emojiRegex from 'emoji-regex'

import { useCurrentChannel } from '~/app/state/hooks'
import { ChannelAvatar } from '~/modules/channel/components'
import { EmojiSelector } from '~/modules/composer/components'
import { EMOJIS } from '~/app/constants'

import {
  Wrapper,
  Row,
  AvatarWrapper,
  ControlWrapper,
  Control,
  Prefill,
  TextArea,
  TextAreaLabel,
  Button,
} from './styles'

const EXTRA_INDENT = 8

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'username' implicitly has an 'any'... Remove this comment to see the full error message
const Composer = ({ username, draft, onSubmit }) => {
  const [usedEmojiPicker, setUsedEmojiPicker] = useState(false)
  const [indent, setIndent] = useState(0)

  const prefillRef = useRef(null)
  const textAreaRef = useRef(null)

  const { getCurrentChannel } = useCurrentChannel()
  const currentChannel = getCurrentChannel()

  useEffect(() => {
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    textAreaRef.current.focus()
  }, [])

  useEffect(() => {
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    const prefillWidth = prefillRef.current.getBoundingClientRect().width
    setIndent(prefillWidth + EXTRA_INDENT)
  }, [prefillRef])

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  const onKeyPress = (event) => {
    const { key, shiftKey } = event
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    const text = textAreaRef.current.value

    if (key === 'Enter' && !shiftKey) {
      onSend(event)
    }
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  const onChange = (event) => {
    updateTextAreaHeight()
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  const onSend = (event) => {
    event.preventDefault()
    event.stopPropagation()

    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    const text = textAreaRef.current.value

    if (!text.trim()) {
      return
    }

    onSubmit(text, {
      usedEmojiPicker,
      hasEmoji: !!emojiRegex().exec(text),
    })

    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    textAreaRef.current.style.height = 'inherit'
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    textAreaRef.current.value = ''

    setUsedEmojiPicker(false)
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'value' implicitly has an 'any' type.
  const onEmojiSelection = (value) => {
    const textAreaEl = textAreaRef.current
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    const currContent = textAreaEl.value
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    const caretPosition = textAreaEl.selectionStart

    const textA = currContent.substring(0, caretPosition) + value
    const textB = currContent.substring(caretPosition)

    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    textAreaEl.value = `${textA}${textB}`
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    textAreaEl.selectionStart = textA.length
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    textAreaEl.selectionEnd = textA.length

    updateTextAreaHeight()

    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    textAreaEl.focus()

    setUsedEmojiPicker(true)
  }

  const updateTextAreaHeight = () => {
    const textAreaEl = textAreaRef.current
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    textAreaEl.style.height = 'inherit'
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    textAreaEl.style.height = `${textAreaEl.scrollHeight}px`
  }

  const { avatar, emojis } = currentChannel || {}
  const emojiList = emojis && emojis.length ? emojis : EMOJIS

  return (
    <Wrapper>
      <Row>
        <AvatarWrapper>
          <ChannelAvatar image={avatar} alt="" />
        </AvatarWrapper>
        <ControlWrapper>
          <Control>
            <Prefill ref={prefillRef}>{username ? `@${username}` : ''}</Prefill>
            <TextAreaLabel htmlFor="text-area">Reply</TextAreaLabel>
            <TextArea
              id="text-area"
              className="mousetrap"
              aria-label="Reply"
              autoComplete="off"
              spellCheck={false}
              ref={textAreaRef}
              rows={1}
              // @ts-expect-error TS(2769) FIXME: No overload matches this call.
              indent={indent}
              defaultValue={draft}
              onChange={onChange}
              onKeyPress={onKeyPress}
            />
          </Control>
          <Button onClick={onSend}>Send</Button>
        </ControlWrapper>
      </Row>
      <EmojiSelector emojis={emojiList} onSelection={onEmojiSelection} />
    </Wrapper>
  )
}

Composer.propTypes = {
  username: PropTypes.string.isRequired,
  draft: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
}

Composer.defaultProps = {
  draft: '',
}

export default Composer
